<!-- @veltra/icons generated sha256:13aaf33d34fa879f gen:8 source:src/svg/normal/user-group.svg -->
<script setup lang="ts">
defineOptions({ name: 'UserGroup' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M6 1q.452 0 .869.117c.317.088.404.472.203.732-.143.184-.392.243-.62.196a2.25 2.25 0 0 0-.991 4.39c.265.065.493.284.493.557 0 .272-.233.508-.508.46A3.25 3.25 0 0 1 6 1m4 7.314a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5m0-1a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M.54 9.436a12.8 12.8 0 0 1 4.916-1.204.48.48 0 0 1 .498.489c0 .272-.22.5-.495.512-1.587.072-3.09.457-4.459 1.092V12h1.365c.276 0 .492.228.492.504a.51.51 0 0 1-.509.496H.5a.5.5 0 0 1-.5-.5v-2.191c0-.372.205-.716.54-.873M16 11.518a.96.96 0 0 0-.541-.873A12.8 12.8 0 0 0 10 9.43a12.8 12.8 0 0 0-5.46 1.215.96.96 0 0 0-.54.873V14a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5zm-1 .016V13a.5.5 0 0 1-.498.501H5.498A.5.5 0 0 1 5 13v-1.466a11.8 11.8 0 0 1 5-1.104c1.787 0 3.476.397 5 1.104"
    />
  </svg>
</template>
